import React, { useState } from 'react';
import Dialog from './Dialog';
import SectionSelect from './SectionSelect';
import useDialogMutation from '../hooks/useDialogMutation';

function MoveAppDialog({ app, sections, currentSectionId, onSubmit, onClose }) {
  const [target, setTarget] = useState(currentSectionId);
  const { run, saving, error } = useDialogMutation();

  return (
    <Dialog title={`Move "${app.name}"`} onClose={onClose} locked={saving}>
      <span id="move-section-label" className="dialog-label">Section</span>
      <SectionSelect
        labelId="move-section-label"
        sections={sections}
        value={target}
        onChange={setTarget}
      />
      {error && <p className="dialog-error" role="alert">{error}</p>}
      <div className="dialog-actions">
        <button type="button" className="btn" onClick={onClose} disabled={saving}>Cancel</button>
        <button
          type="button"
          className="btn btn-primary"
          disabled={target === currentSectionId || saving}
          onClick={() => run(() => onSubmit(target), onClose)}
        >
          {saving ? 'Saving…' : 'Move'}
        </button>
      </div>
    </Dialog>
  );
}

export default MoveAppDialog;